import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { MatSnackBar, MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LocalstorageService } from '../../../services/localstorage/localstorage.service';
import { HttpService } from '../../../services/http/http.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  jobApplication: FormGroup;
  disabled: boolean = false;
  showOtp: boolean = false;
  data: any = {};
  digitExp = '^[0-9]*$';
  nameExp = '[a-zA-Z ]*$';
  contactExp = '^[6-9]{1}[0-9]{9}$';
  // emailExp = '^([a-zA-Z0-9][.-_]?)+@([a-zA-Z0-9]+[.-]?)*[a-zA-Z0-9][.][a-zA-Z]{2,3}$';
  emailExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  userId = "";
  cid = "";
  uid = "";
  otp = "";
  phoneNumber1 = "";
  textBoxDisabled = false;
  token = "";
  token1 = "";
  stage = "";
  gender = "";
  currentYear = new Date().getFullYear();
  OTP = new FormControl(null, [Validators.required, Validators.pattern(this.contactExp), this.noWhitespaceValidator]);
  fullName = new FormControl(null, [Validators.required, Validators.pattern(this.nameExp),
  this.noWhitespaceValidator, Validators.minLength(2)]);
  email = new FormControl(null, [Validators.required, Validators.pattern(this.emailExp)]);
  phoneNumber = new FormControl(null, [Validators.required, Validators.pattern(this.contactExp)]);

  constructor(public dialog: MatDialog,
    private httpService: HttpService,
    private localstorageService: LocalstorageService,
    private spinnerService: Ng4LoadingSpinnerService,
    private fb: FormBuilder, public route: ActivatedRoute,
    private snackbar: MatSnackBar,
    private router: Router
  ) {
    this.route.queryParams.subscribe(params => {
      this.cid = params['cid'];
      // console.log(this.cid);
      localStorage.setItem('campaignId', this.cid);
      this.token1 = params['token'];
      this.otp = params['otp'];
      this.stage = params['stage'];
      // console.log(params);
      
      if (this.token1 !== '' && this.stage !== '') {
        localStorage.setItem('token', this.token1);
        if (this.stage == 'START_TEST_PENDING') {
          let userId = params['userId'];
          let username = params['username'];
          let campaignId = params['campaignId'];
          let currentPinCode = params['currentPinCode'];

          localStorage.setItem('userId', userId);
          localStorage.setItem('name', username);
          localStorage.setItem('campaignId', campaignId);
          localStorage.setItem('currentPinCode', currentPinCode);

          this.httpService.redirectTo("/test");
        } else if (this.stage == 'ADDTIONAL_INFORMATION_PENDING') {
          let userId = params['userId'];
          let username = params['username'];
          let campaignId = params['campaignId'];
          let currentPinCode = params['currentPinCode'];

          // console.log(params);
          
          localStorage.setItem('userId', userId);
          localStorage.setItem('name', username);
          localStorage.setItem('campaignId', campaignId);
          localStorage.setItem('currentPinCode', currentPinCode);

          if(currentPinCode === ''){
            this.httpService.redirectTo("/stage/additionalInfo");
          }
        } else if (this.stage == 'OTP_VERIFICATION_PENDING' || this.stage == 'END_TEST_PENDING'
          || this.stage == 'RETRY_TEST_PENDING') {
          let campaignId = params['campaignId'];
          let type = params['type'];
          let refType = params['refType'];

          if (type == 'reg') {
            this.router.navigate([''], { queryParams: { cid: campaignId, type: type, refType: refType } });
          } else {
            console.log("home");
            
            this.router.navigate(['/'], { queryParams: { 'type': type ,'cid': campaignId} });
          }
        }
      }
    });
    // http://codingtest.bridgelabz.com/register?
    // token=eyJhbGciOiJIUzI1NiJ9.eyJjYW1wYWlnbklkIjoiVGxkT2FGcHFSbXRPYWtVd1dUSldhMXB0VVhkTlJFRXlUWHBXYlU5VVZUVT0iLCJ0ZXN0SWQiOiIiLCJleHAiOjE1NTUwNzEwMDAsInVzZXJJZCI6IjVjYWYzZTE4NGNlZGZkMDAwNmM4NzVjOCJ9.fmVP7VtSJRzLVLbMjL0iq_JSfEOmS7RRAX3OOCH1aBc
    // &
    // stage=OTP_VERIFICATION_PENDING
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  ngOnInit() {
    var campaignId = localStorage.getItem('campaignId');
    var campaignType = localStorage.getItem('campaignType');
    // console.log("campaignid", campaignId);
    // console.log("campaignType", campaignType);
    localStorage.clear();
    localStorage.setItem('campaignId', campaignId);
    localStorage.setItem('campaignType', campaignType);

    this.jobApplication = this.fb.group({
      fullName: [null, Validators.compose([Validators.required, Validators.minLength(2),
      Validators.maxLength(20), Validators.pattern('[a-zA-Z]+')])],
      email: [null, Validators.compose([Validators.required, Validators.maxLength(50),
      Validators.pattern('^([a-zA-Z0-9][.-_]?)+@([a-zA-Z0-9]+[.-]?)*[a-zA-Z0-9][.][a-zA-Z]{2,3}$')])],
      phoneno: [null, Validators.compose([Validators.required, Validators.pattern('^[6-9]{1}[0-9]{9}$')])],

    });
    this.inputAutoCompleteDisable();
    if (this.otp != null && this.otp != undefined && this.otp != "") {
      localStorage.setItem('token', this.token1);
      this.OTP = new FormControl(this.otp, [Validators.required, Validators.pattern(this.contactExp), this.noWhitespaceValidator]);
      // this.userId=this.uid;
      this.verifyOTP();
    }
  }
  inputAutoCompleteDisable() {
    setTimeout(() => {
      const inputs = document.getElementsByTagName('input');
      for (let index = 0; inputs[index]; index++) {
        const inputElement = inputs[index];
        inputElement.setAttribute('autocomplete', 'off');
      }
    }, 500);
  }

  getErrorForEmail() {
    return this.email.hasError('required') ? 'Email can\'t be blank' :
      this.email.hasError('email') ? 'Please provide proper email' :
        this.email.hasError('pattern') ? 'Please provide proper email' : '';
  }
  getErrorForOTP() {
    return this.OTP.hasError('required') ? 'OTP can\'t be blank' :
      this.OTP.hasError('pattern') ? 'Please provide valid OTP' :
        this.OTP.hasError('whitespace') ? 'Please provide valid OTP' :
          '';
  }

  getErrorForPhoneNumber() {
    return this.phoneNumber.hasError('required') ? 'Phone number can\'t be blank' :
      this.phoneNumber.hasError('pattern') ? 'Please provide valid phone number' : '';
  }
  getErrorForFullName() {
    return this.fullName.hasError('required') ? 'Full name can\'t be blank' :
      this.fullName.hasError('whitespace') ? 'Please provide valid full name' :
        this.fullName.hasError('pattern') ? 'Full name can\'t contains digits or any special character' :
          this.fullName.hasError('minlength') ? 'Full name length should be greater than 1' : '';

  }


  keyPress(event: any) {
    const pattern = /[0-9]/;
    // console.log(event.keyCode);
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }
  }
  keyPressButton(event: any) {
    if (event.keyCode === 13) {
      this.register();
    }
  }
  keyPressButton1(event: any) {
    if (event.keyCode === 13) {
      this.verifyOTP();
    }
  }

  lastKeyCode(str) {
    return str.charCodeAt(str.length - 1);
  }

  register() {
    this.data = {
      fullName: this.fullName.value.trim(),
      emailId: this.email.value.trim(),
      phoneNumber: this.phoneNumber.value.trim(),
      gender: this.gender,
      cid: this.cid
    }
    console.log("Data", this.data);
    if (this.data.fullName && this.data.emailId && this.data.phoneNumber != null) {
      this.spinnerService.show();
      console.log("model: ", this.data);
      var contentBody = { url: "/users", body: this.data }
      this.httpService.httpPost(contentBody, false).subscribe(response => {
        console.log("success ", response);
        this.userId = response["id"];
        this.token = response["token"];
        this.localstorageService.setData('token', this.token)
        this.localstorageService.setData('userId', this.userId)
        this.fullName.setValue(this.fullName.value.trim())
        this.email.setValue(this.email.value.trim())
        // console.log(response["user"].id)
        this.showOtp = true;
        this.textBoxDisabled = true;
        this.disabled = true;
        this.spinnerService.hide();
        this.OTP = new FormControl("", [Validators.required, Validators.pattern(this.digitExp), this.noWhitespaceValidator]);
        // if(response == undefined) {
        //   this.openSnackBar("Network Error")
        // }
        // else {
        this.openSnackBar(response["message"]);
        // }
      }, error => {
        console.log("err ", error);
        this.showOtp = false;
        this.textBoxDisabled = false;
        this.disabled = false;
        this.spinnerService.hide();
        this.openSnackBar(error.error.message);
      })
    }
    else {
      this.showOtp = false;
    }
  }

  verifyOTP() {
    console.log("Verify OTP");
    var data = {
      otp: this.OTP.value
    }
    if (data.otp) {
      this.spinnerService.show();
      var contentBody = { url: "/users/verifyotp", body: data }
      this.httpService.httpPost(contentBody, true).subscribe(response => {
        console.log("success ", response);
        if (response["testAttemptCount"] >= response["maxAttemptCount"]) {
          this.spinnerService.hide();
          this.openSnackBar("Your OTP is not verified")
        }
        else {
          console.log("verify respone", response);

          this.localstorageService.setData("token", response["token"])
          this.localstorageService.setData("userId", response["id"])
          this.localstorageService.setData("name", response["name"]);
          if (response["currentPinCode"] != undefined && response["currentPinCode"] != null && response["currentPinCode"] != "") {
            this.localstorageService.setData("currentPinCode", response["currentPinCode"]);
          }
          else {
            this.localstorageService.setData("currentPinCode", "");
          }
          this.spinnerService.hide();
          // this.openSnackBar("sdfwf");
          this.httpService.redirectTo("/test");
        }
      }, error => {
        console.log("error ", error);
        this.spinnerService.hide();
        this.openSnackBar(error.error.message);
      })
    }
    else {
    }
  }
  resendOTP() {
    this.spinnerService.show();
    var contentBody = { url: "/users/resendotp" }
    this.httpService.httpPost(contentBody, true).subscribe(response => {
      console.log("success ", response);
      this.spinnerService.hide();
      this.openSnackBar(response["message"]);
    }, error => {
      console.log("error ", error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    })
  }
  openSnackBar(message: string) {
    if (message == null || message == "" || message == undefined) {
      this.snackbar.open("Network Error", null, {
        duration: 5000
      });
    }
    else {
      this.snackbar.open(message, null, {
        duration: 5000
      });
    }
  }

  focusOutFunction() {
    var data = {
      emailId: this.email.value
    }
    this.spinnerService.show();
    var contentBody = { url: "/users/getuserdata", body: data }

    this.httpService.httpPost(contentBody, false).subscribe(response => {
      // console.log("success ", response);
      this.fullName.setValue(response["fullName"])
      this.spinnerService.hide();
      // this.openSnackBar(response["message"]);

    }, error => {
      // console.log("error ", error);
      this.spinnerService.hide();
      // this.openSnackBar(error.error.message);
    })
  }
}


